import { css, html, htmlArray } from "../helpers/webComponents";
import { GameEventService } from "../services/GameEventService";
import { Page } from "../enums/Page";

/** CSS voor de HintComponent */
const styles: string = css`
    :host {
        font-family: "Onesize";
        width: 100%;
        max-width: 1024px;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 20px;
    }

    .hint-container {
        background-color: #52478b;
        border: 2px solid #332c57;
        border-radius: 10px;
        padding: 30px;
        max-width: 500px;
        text-align: center;
    }

    .hint-title {
        font-size: 24px;
        margin-bottom: 20px;
        color: #fff;
        text-transform: uppercase;
    }

    .hint-content {
        font-size: 18px;
        margin-bottom: 30px;
        color: #fff;
        background-color: #7f6ed7;
        padding: 20px;
        border-radius: 5px;
        border: 1px solid #332c57;
    }

    .back-button {
        background-color: #7f6ed7;
        border: 1px solid #332c57;
        padding: 10px 20px;
        text-transform: uppercase;
        cursor: pointer;
        display: inline-block;
        user-select: none;
        color: #fff;
    }

    .back-button:hover {
        background-color: #332c57;
    }
`;

/**
 * Web Component voor het tonen van een hint aan de speler
 */
export class HintComponent extends HTMLElement {
    /** Instance van de game event service */
    private readonly _gameEventService: GameEventService = new GameEventService();

    /**
     * De "constructor" van een Web Component
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });
        this.render();
    }

    /**
     * Render de inhoud van deze pagina
     */
    private render(): void {
        if (!this.shadowRoot) {
            return;
        }

        const elements: HTMLElement[] = htmlArray`
            <style>
                ${styles}
            </style>

            <div class="hint-container">
                <div class="hint-title">Hint</div>
                <div class="hint-content">
                    The hint is: Chicken
                </div>
                ${this.renderBackButton()}
            </div>
        `;

        while (this.shadowRoot.firstChild) {
            this.shadowRoot.firstChild.remove();
        }

        this.shadowRoot.append(...elements);
    }

    /**
     * Render de terug knop
     *
     * @returns HTML element van de terug knop
     */
    private renderBackButton(): HTMLElement {
        const element: HTMLElement = html`
            <a class="back-button">Back to Game</a>
        `;

        element.addEventListener("click", () => this.handleBackButton());

        return element;
    }

    /**
     * Handle de klik op de terug knop
     */
    private handleBackButton(): void {
        this._gameEventService.switchPage(Page.Canvas);
    }
}
